<template>
  <div>
    <portal-target name="dropdown" slim/>
    <div class="min-h-screen flex flex-col" @click="hideDropdownMenus">
      <div class="header-first-line top-right links grid grid-cols-3 gap-4">
        <div></div>
        <div class="flex justify-center mt-2">
          <a :href="'https://www.artmark.ro'+ currentLocale()">
            <img src="/dda_orizontala.png" alt="Logo DDA" style="height: 40px !important;margin-top: 5px;"/>
          </a>
        </div>
        <div class="flex justify-end">
          <a v-if="$page.auth.user"
             style="font-family: Montserrat,sans-serif !important; color: #3c3c3c"
             class="mt-4 px-2 py-2 uppercase hover:text-gray-700 transition ease-in-out duration-150 small"
             :href="route('account.home')" target="_blank">
            {{ $t('account.my_account') }}
          </a>
          <a v-else style="font-family: Montserrat,sans-serif !important; color: #3c3c3c"
             class="mt-4 px-2 py-2 uppercase hover:text-gray-700 transition ease-in-out duration-150 small"
             :href="route('login')">
            {{ $t('account.login') }}
          </a>
          <inertia-link v-if="$page.auth.user"
                        style="font-family: Montserrat,sans-serif !important; background-color: #343A40;"
                        class="mt-5 mb-3 px-2 py-1 uppercase text-white transition ease-in-out duration-150 small"
                        :href="route('shop.logout')" method="post">
            {{ $t('account.logout') }}
          </inertia-link>
          <inertia-link v-else
                        style="font-family: Montserrat,sans-serif !important; background-color: #343A40;"
                        class="mt-5 mb-3 px-2 py-1 uppercase text-white transition ease-in-out duration-150 small"
                        :href="route('shop.register')">
            {{ $t('account.register') }}
          </inertia-link>
          <div class=" dropdown inline-block relative py-2" style="float: right; z-index:99999;">
            <div class="flex flex-row m-2 mt-3">
              <p style="color: #3c3c3c;" class="mr-2"> | </p>
              <div v-if="isRo()">
                <i class="sl-flag flag-ro center-vertically"></i> <i class="fa fa-angle-down" aria-hidden="true"></i>
              </div>
              <div v-else>
                <i class="sl-flag flag-en center-vertically"></i> <i class="fa fa-angle-down" aria-hidden="true"></i>
              </div>
              <font-awesome-icon :icon="['fa', 'angle-down']" style="margin-left: 0.2rem"/>
            </div>
            <ul class="dropdown-menu absolute hidden text-gray-700 pt-1"
                style="box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 8px !important;">

              <button style=" padding: 5px;font-size: 12px; margin: 5px;"
                      v-for="entry in languages" :key="entry.title"
                      @click="changeLocale(entry.language)">
                <div class="flex flex-row ">
                  <i class="sl-flag center-vertically" v-bind:class="'flag-' + entry.language"></i> <i
                    class="fa fa-angle-down" aria-hidden="true"></i>
                  <p class="pl-2"> {{ entry.title }} </p>
                </div>
              </button>
            </ul>
          </div>
        </div>
      </div>
      <div class="lg:flex border-b border-t py-2 sticky top-0 header-menu" style="height: 100px !important;">
        <div
            class="lg:flex-shrink-0 lg:w-56 px-5 flex items-center justify-between lg:justify-center lg:ml-24 logo-header">
          <inertia-link class="mt-1" :href="currentLocale()">
            <logo width="45px"/>
          </inertia-link>
          <div class="lg:hidden flex flex-row items-center">
            <div>
              <svg @click="navState ? closeNav() : openNav()"
                   class="text-gray-700 hover:text-gray-900 w-8 h-8 transition ease-in-out duration-150 cursor-pointer"
                   fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                   viewBox="0 0 24 24" stroke="currentColor">
                <path d="M4 6h16M4 12h16M4 18h16"></path>
              </svg>

            </div>
          </div>
          <div id="stickyCartContainer">
            <div id="fixedCart">
              <inertia-link
                  class="mr-3 flex cart-container flex-row items-center group text-gray-700 hover:text-gray-900 transition ease-in-out duration-150"
                  :href="route('shop.cart.view')">
                <!-- DESKTOP CART ICON -->
                <svg class="w-5 h-5 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                     width="24"
                     height="24">
                  <path class="heroicon-ui"
                        d="M17 16a3 3 0 1 1-2.83 2H9.83a3 3 0 1 1-5.62-.1A3 3 0 0 1 5 12V4H3a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1v1h14a1 1 0 0 1 .9 1.45l-4 8a1 1 0 0 1-.9.55H5a1 1 0 0 0 0 2h12zM7 12h9.38l3-6H7v6zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                </svg>
                <span class="cart a10-nav-link"><sup class="cart_quantity">{{
                    Object.keys($page.cart.items).length
                  }}</sup></span>
              </inertia-link>
            </div>
          </div>
        </div>
        <div
            class="hidden main-menu-header lg:flex bg-white w-full p-4 lg:py-0 lg:pr-12 lg:pl-0 text-sm lg:text-base flex justify-between items-center lg:ml-24">
          <main-menu :url="url()" :categories="categories" class="uppercase"/>
          <div class="flex flex-row items-center mr-4">
            <inertia-link
                class="mr-3 flex cart-container flex-row items-center group text-gray-700 hover:text-gray-900 transition ease-in-out duration-150"
                :href="route('shop.cart.view')">
              <!-- DESKTOP CART ICON -->
              <svg class="w-5 h-5 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                   width="24"
                   height="24">
                <path class="heroicon-ui"
                      d="M17 16a3 3 0 1 1-2.83 2H9.83a3 3 0 1 1-5.62-.1A3 3 0 0 1 5 12V4H3a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1v1h14a1 1 0 0 1 .9 1.45l-4 8a1 1 0 0 1-.9.55H5a1 1 0 0 0 0 2h12zM7 12h9.38l3-6H7v6zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
              </svg>
              <span class="cart a10-nav-link"><sup class="cart_quantity">{{
                  Object.keys($page.cart.items).length
                }}</sup></span>
            </inertia-link>
            <form @submit.prevent="search"
                  class="flex justify-center items-center w-full max-w-xs relative group">
              <text-input v-bind:placeholder="$t('misc.search')" v-model="searchKeywords"
                          class="w-full a10-nav-link uppercase text-gray-400 input-search-form"
                          type="text" style="border: none !important"/>
              <svg @click="search"
                   class="text-gray-700 group-hover:text-gray-900 fill-current absolute mt-1 mr-2 inset-y-0 right-0 cursor-pointer w-5 h-5 transition ease-in-out duration-150"
                   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                <path class="heroicon-ui"
                      d="M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"/>
              </svg>
            </form>

          </div>
        </div>
        <MegaMenu v-if="showMegaMenu == true" :categories="categories"/>
      </div>
      <div v-if="isOnHomepage()">
        <!--        <MegaMenu v-if="showMegaMenu == true" :categories="categories"/>-->
        <div class="mx-auto overflow-hidden py-6 px-0 md:px-4 relative lg:ml-36 lg:mr-36">
          <flash-messages/>
          <slot/>
        </div>
      </div>
      <div v-else>
        <!--        <MegaMenu v-if="showMegaMenu == true" :categories="categories"/>-->
        <div class="mx-auto overflow-hidden py-6 px-4 relative lg:ml-36 lg:mr-36">
          <slot name="sticky"></slot>
          <flash-messages/>
          <slot/>
        </div>
      </div>
      <div>
        <newsletter/>
      </div>
      <div>
        <footer-layout/>
      </div>
    </div>

    <transition
        enter-active-class="ease-in-out duration-500"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in-out duration-500"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
    >
      <div v-show="navState" class="fixed inset-0 overflow-hidden z-50">
        <div class="absolute inset-0 overflow-hidden">
          <transition
              enter-active-class="ease-in-out duration-500"
              enter-class="opacity-0"
              enter-to-class="opacity-100"
              leave-active-class="ease-in-out duration-500"
              leave-class="opacity-100"
              leave-to-class="opacity-0"
          >
            <div @click="closeNav()" v-show="navState"
                 class="absolute inset-0 bg-gray-700 bg-opacity-75 transition-opacity"></div>
          </transition>

          <section class="absolute inset-y-0 right-0 pl-10 max-w-full flex">
            <transition
                enter-active-class="transform transition ease-in-out duration-500 sm:duration-700"
                enter-class="translate-x-full"
                enter-to-class="translate-x-0"
                leave-active-class="transform transition ease-in-out duration-500 sm:duration-700"
                leave-class="translate-x-0"
                leave-to-class="translate-x-full"
            >
              <div v-show="navState" class="w-screen max-w-xs">
                <div class="relative h-full flex flex-col space-y-6 py-6 bg-white shadow-xl overflow-y-scroll">
                  <header class="px-4 sm:px-6 pt-20">
                    <div class="flex items-start justify-between space-x-3">
                      <form @submit.prevent="search(); closeNav()"
                            class="flex justify-center items-center w-full max-w-md relative group">
                        <text-input v-bind:placeholder="$t('misc.search')"
                                    v-model="searchKeywords"
                                    class="w-full" type="text"/>
                        <svg fill="#3c3c3c" @click="search(); closeNav()"
                             class="search-icon w-6 h-6 r-svg-medium" markup-inline=""
                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.8 31.8">
                          <path
                              d="M11.1 0C5 0 0 5 0 11.1c0 6.2 5 11.1 11.1 11.1s11.1-5 11.1-11.1C22.3 5 17.3 0 11.1 0zm0 19.1c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm20.3 10l-8-8c-.6-.6-1.6-.6-2.3 0s-.6 1.6 0 2.3l8 8c.3.3.7.5 1.1.5s.8-.2 1.1-.5c.7-.6.7-1.7.1-2.3z"></path>
                        </svg>
                        <!-- <svg
                             class="text-gray-700 group-hover:text-gray-900 fill-current absolute mt-1 mr-2 inset-y-0 right-0 cursor-pointer transition ease-in-out duration-150"
                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24"
                             height="24">
                            <path class="heroicon-ui"
                                  d="M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"/>
                        </svg> -->
                      </form>
                    </div>
                  </header>
                  <div class="relative flex-1 px-4 sm:px-6">
                    <!-- Replace with your content -->
                    <div class="absolute inset-0 px-4 sm:px-6">
                      <div class="h-full flex flex-col justify-between">
                        <div class="flex flex-col">
                          <main-menu-dropdown @close="closeNav()" :categories="categories" class="mb-8"/>
                        </div>

                        <div>
                          <inertia-link @click="closeNav()"
                                        class="flex flex-row items-center justify-between py-2 border-b hover:bg-gray-800 hover:text-white transition ease-in-out duration-150"
                                        :href="route('shop.cart.view')">
                            <span>Vezi coșul</span>
                            <div class="flex flex-row items-center cart-container">
                              <!--CART ICON AND FOR MOBILE-->
                              <svg class="w-6 h-6 fill-current"
                                   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                   width="24"
                                   height="24">
                                <path class="heroicon-ui"
                                      d="M17 16a3 3 0 1 1-2.83 2H9.83a3 3 0 1 1-5.62-.1A3 3 0 0 1 5 12V4H3a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1v1h14a1 1 0 0 1 .9 1.45l-4 8a1 1 0 0 1-.9.55H5a1 1 0 0 0 0 2h12zM7 12h9.38l3-6H7v6zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                              </svg>
                              <span class="cart mobile-cart"><sup
                                  class="cart_quantity">{{ Object.keys($page.cart.items).length }}</sup></span>
                            </div>
                          </inertia-link>

                          <inertia-link v-if="$page.auth.user" @click="closeNav()"
                                        class="block py-2 border-b hover:bg-gray-800 hover:text-white transition ease-in-out duration-150"
                                        :href="route('shop.account')">
                            {{ $t('account.my_account') }}
                          </inertia-link>
                          <inertia-link v-else @click="closeNav()"
                                        class="block py-2 border-b hover:bg-gray-800 hover:text-white"
                                        :href="route('shop.login')">
                            {{ $t('account.login') }}
                          </inertia-link>

                          <inertia-link v-if="$page.auth.user" @click="closeNav()"
                                        class="block py-2 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150"
                                        :href="route('shop.logout')" method="post">
                            {{ $t('account.logout') }}
                          </inertia-link>
                          <inertia-link v-else @click="closeNav()"
                                        class="block py-2 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150"
                                        :href="route('shop.register')">
                            {{ $t('account.register') }}
                          </inertia-link>
                        </div>

                      </div>
                    </div>
                    <!-- /End replace -->
                  </div>
                </div>
              </div>
            </transition>
          </section>
        </div>
      </div>
    </transition>
    <div>

      <!-- Full Popup -->

      <!-- Full Popup -->
      <div v-if="popupVisible && !minimized" class="popup">
        <div class="popup-header">
          <h2 class="popup-header-title">OFERTA ZILEI</h2>
          <button class="popup-close-button" @click="minimizePopup">&times;</button>
        </div>
        <div v-for="(lot, index) in ofertaZilei" :key="index" style="padding: 15px 15px 15px 15px">
          <inertia-link class="flex justify-center" :href="route('shop.lot.view', lot.slug)">
            <img class="img-fluid" :src="lot.auction_listing_image" :alt="`Image of ${lot.title}`"/>
            <div v-if="lot.shop_status === 2" class="top-left" style=" margin: 0px auto; text-align: center; width: 65px; background-color: black; height: 65px; line-height: 65px;   border-radius: 50%;   font-size: 14px;   color: rgb(255, 255, 255);   position: absolute;     top: 42%;
    left: 50%; transform: translate(-50%, -50%);">
              Sold
            </div>
          </inertia-link>
          <div class="pt-2 flex justify-between items-start">
            <inertia-link :href="route('shop.lot.view', lot.slug)"><h2
                class="a10-lot-listing-title group-hover:text-black transition ease-in-out duration-150"
                v-html="makeLotTitle(lot, true)"></h2></inertia-link>
          </div>
          <div class="flex justify-between items-center pt-3">
            <div>
              <h4 class="a10-lot-listing-author">
                <span v-html="makeArtistLink(lot.artists)"></span>
                <div v-if="!lot.artists && lot.old_artist">
                  {{ lot.old_artist }}
                </div>
              </h4>
              <h4 v-if="lot.shop_status === 2" class="a10-lot-listing-price">
                {{ $t('cart.sold_for') }}: &euro; {{ lot.formatted_shop_price }}
              </h4>
              <h4 v-else-if="lot.shop_status !== 2" class="a10-lot-listing-price">
                  <span v-if="lot.custom_shop_price"><s>{{ $t('cart.sell_price') }}: &euro; {{
                      lot.formatted_shop_price
                    }}</s>
                  <br/>
                    <span v-if="lot.shop_price_first_discount"><s>{{
                        $t('cart.discount_sell_price')
                      }}: &euro; {{ lot.shop_price_first_discount }}</s></span>
                    <br/>
                    <span style="color:darkred"><b>{{ $t('cart.custom_sell_price') }}: &euro; {{
                        lot.custom_shop_price
                      }}</b></span>
                  </span>
                <span v-else-if="lot.shop_discount_price">
                    <span><s>{{ $t('cart.sell_price') }}: &euro; {{ lot.formatted_shop_price }}</s></span>
                  <br/>
                    <span v-if="lot.shop_discount_price" style="color:darkred">{{ $t('cart.discount_sell_price') }}: &euro; {{
                        lot.shop_discount_price
                      }}</span>
                  </span>
                <span v-else>{{ $t('cart.sell_price') }}: &euro; {{ lot.formatted_shop_price }}</span>
              </h4>

            </div>
            <div class="favShare">
              <inertia-link v-if="lot.is_gift" :href="route('shop.category.view', 'gifts')"><img
                  src="/assets/img/icons/3-01.png" height="20" width="20"
                  style="display: inline; vertical-align: top;margin-right: 5px"/></inertia-link>
              <dropdown placement="bottom-center" :overlay="false">
                <div class="flex items-center cursor-pointer select-none group">
                  <div
                      class="text-grey-700 group-hover:text-gray-900 focus:text-gray-900 mr-1 whitespace-no-wrap transition ease-in-out duration-150">
                    <svg class="text-gray-700 hover:text-gray-900 fill-current w-5 h-5"
                         enable-background="new 0 0 512 512" viewBox="0 0 512 512"
                         xmlns="http://www.w3.org/2000/svg">
                      <g>
                        <path
                            d="m407 302c-35.66 0-67.219 17.873-86.205 45.127l-116.132-58.066c3.458-10.4 5.337-21.515 5.337-33.061s-1.879-22.661-5.337-33.061l116.132-58.066c18.986 27.254 50.545 45.127 86.205 45.127 57.897 0 105-47.103 105-105s-47.103-105-105-105-105 47.103-105 105c0 11.546 1.879 22.661 5.337 33.061l-116.132 58.066c-18.986-27.254-50.545-45.127-86.205-45.127-57.897 0-105 47.103-105 105s47.103 105 105 105c35.66 0 67.219-17.873 86.205-45.127l116.132 58.066c-3.458 10.4-5.337 21.515-5.337 33.061 0 57.897 47.103 105 105 105s105-47.103 105-105-47.103-105-105-105zm0-272c41.355 0 75 33.645 75 75s-33.645 75-75 75-75-33.645-75-75 33.645-75 75-75zm-302 301c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75zm302 151c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75z"></path>
                      </g>
                    </svg>
                  </div>
                </div>
                <div slot="dropdown" class="mt-2 shadow-xl bg-white text-sm">
                  <a :href="lot.shop_facebook_share_link"
                     class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                    <svg class="fill-current w-4 h-4 text-sm" xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
                         width="24px" height="24px" viewBox="0 0 90 90" xml:space="preserve">
                            <path
                                d="M90,15.001C90,7.119,82.884,0,75,0H15C7.116,0,0,7.119,0,15.001v59.998 C0,82.881,7.116,90,15.001,90H45V56H34V41h11v-5.844C45,25.077,52.568,16,61.875,16H74v15H61.875C60.548,31,59,32.611,59,35.024V41  h15v15H59v34h16c7.884,0,15-7.119,15-15.001V15.001z"
                                data-original="#000000" class="active-path"/>
                          </svg>
                    <span class="pl-2">Facebook</span>
                  </a>
                  <a :href='"mailto: ?subject=Recomand Dependent de Artă - " + lot.title + "&body=Recomand Dependent de Artă - " + lot.title + "%0D%0A"'
                     class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                    <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round"
                         stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                    </svg>
                    <span class="pl-2">Email</span>
                  </a>
                  <div @click="copyToClipboard(lot)"
                       class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                    <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round"
                         stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                          d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"></path>
                    </svg>
                    <span class="pl-2">Copiază link-ul</span>
                  </div>
                </div>
              </dropdown>
            </div>
          </div>
          <div class="pt-2 flex justify-center">
            <div :id="'addToCart_wrapper'">
              <button v-if="lot.shop_status == 0 && inArray(lot.id) == false" @click="addToCart(lot.id)"
                      class="btn-gray ">{{ $t('cart.add_cart') }}
              </button>
              <a v-else-if="lot.shop_status == 0 && inArray(lot.id) == true" :href="route('shop.cart.view')"
                 style='background: #48bb78;' class="btn-gray a10-btn-padding addToCartDisabled"><span
                  v-html="$t('cart.added_cart_category')"></span></a>
            </div>
          </div>

        </div>
      </div>

      <!-- Minimized Popup -->
      <div v-if="ofertaZilei.length > 0 && minimized" class="minimized-popup" @click="restorePopup">
        <p>OFERTA ZILEI</p>
      </div>
    </div>
  </div>
</template>

<style>
.header-menu {
  z-index: 99;
  background: white;
}

.dropdown:hover .dropdown-menu {
  display: block;
  position: absolute;
  background: white;

}

/*search form input */
#text-input-13 {
  border: none !important;
  font-size: 0.8rem !important;
  width: 280px !important;
}

#text-input-13::placeholder {
  color: grey !important;
}

#text-input-13:focus {
  border-bottom: 1px solid black !important;
}

.small {
  font-size: 80%;
  font-weight: 400;
}

flag {
  background-size: cover;
  background-position: 50%;
  width: 12px;
  height: 12px;
}

.sl-flag {
  display: inline-block;

  width: 17px;
  height: 13px;
  position: relative;
  top: 2px;
  overflow: hidden;
}

.flag-ro {
  background-image: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij4KPHBhdGggc3R5bGU9ImZpbGw6IzQxNDc5QjsiIGQ9Ik0xNzAuNjY3LDQyMy43MjFIOC44MjhjLTQuODc1LDAtOC44MjgtMy45NTMtOC44MjgtOC44MjhWOTcuMWMwLTQuODc1LDMuOTUzLTguODI4LDguODI4LTguODI4ICBoMTYxLjgzOVY0MjMuNzIxeiIvPgo8cmVjdCB4PSIxNzAuNjciIHk9Ijg4LjI3NyIgc3R5bGU9ImZpbGw6I0ZGRTE1QTsiIHdpZHRoPSIxNzAuNjciIGhlaWdodD0iMzM1LjQ1Ii8+CjxwYXRoIHN0eWxlPSJmaWxsOiNGRjRCNTU7IiBkPSJNNTAzLjE3Miw0MjMuNzIxSDM0MS4zMzNWODguMjczaDE2MS44MzljNC44NzUsMCw4LjgyOCwzLjk1Myw4LjgyOCw4LjgyOHYzMTcuNzkzICBDNTEyLDQxOS43Nyw1MDguMDQ3LDQyMy43MjEsNTAzLjE3Miw0MjMuNzIxeiIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K");
  background-size: cover;
  background-position: center center;
  width: 20px;
  height: 20px;
}

.flag-en {
  background-image: url("data:image/svg+xml;utf8;base64,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");
  background-size: cover;
  background-position: center center;
  width: 20px;
  height: 20px;
}

.flag-zh-cn {
  background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0RFMjkxMDt9Cgkuc3Qxe2ZpbGw6I0ZGREUwMDt9Cjwvc3R5bGU+CjxyZWN0IHk9Ijg1LjciIGNsYXNzPSJzdDAiIHdpZHRoPSI1MTIiIGhlaWdodD0iMzQwLjYiLz4KPGc+Cgk8cG9seWdvbiBjbGFzcz0ic3QxIiBwb2ludHM9IjEwMy4zLDE3Ni45IDEzMy4zLDE1NS4xIDk2LjIsMTU1LjEgODQuNywxMTkuOCA3My4yLDE1NS4xIDM2LjEsMTU1LjEgNjYuMSwxNzYuOSA1NC43LDIxMi4yCgkJODQuNywxOTAuNCAxMTQuNywyMTIuMiAJIi8+Cgk8cG9seWdvbiBjbGFzcz0ic3QxIiBwb2ludHM9IjE3NC44LDEyNCAxODYuOCwxMjEuMiAxNzUuNCwxMTYuNCAxNzYuNSwxMDQuMSAxNjguNCwxMTMuNCAxNTcsMTA4LjYgMTYzLjQsMTE5LjIgMTU1LjIsMTI4LjUKCQkxNjcuMywxMjUuNyAxNzMuNywxMzYuMyAJIi8+Cgk8cG9seWdvbiBjbGFzcz0ic3QxIiBwb2ludHM9IjIwNi44LDE1OS43IDIxOSwxNjEuOCAyMTAuNCwxNTIuOSAyMTYuMSwxNDIgMjA1LDE0Ny40IDE5Ni40LDEzOC41IDE5OC4yLDE1MC44IDE4Ny4xLDE1Ni4yCgkJMTk5LjIsMTU4LjMgMjAxLDE3MC42IAkiLz4KCTxwb2x5Z29uIGNsYXNzPSJzdDEiIHBvaW50cz0iMjEwLjIsMjA2LjcgMjE5LjksMTk5LjEgMjA3LjUsMTk5LjUgMjAzLjMsMTg3LjkgMTk5LjksMTk5LjggMTg3LjUsMjAwLjIgMTk3LjgsMjA3LjEgMTk0LjQsMjE5CgkJMjA0LjEsMjExLjQgMjE0LjQsMjE4LjMgCSIvPgoJPHBvbHlnb24gY2xhc3M9InN0MSIgcG9pbnRzPSIxNzQuOSwyNDMgMTg2LjksMjM5LjggMTc1LjMsMjM1LjQgMTc1LjksMjIzIDE2OC4xLDIzMi43IDE1Ni42LDIyOC4zIDE2My40LDIzOC43IDE1NS42LDI0OC4zCgkJMTY3LjYsMjQ1LjEgMTc0LjQsMjU1LjQgCSIvPgo8L2c+Cjwvc3ZnPgo=");
  background-size: cover;
  background-position: center center;
  width: 20px;
  height: 20px;
}

@media (max-width: 1457px) and (min-width: 1024px) {
  #text-input-13 {
    width: 150px !important;
  }

  .main-menu-header, .logo-header {
    margin-left: 0 !important;
  }
}

@media (max-width: 767px) {
  .header-first-line {
    display: none !important;
  }

  .stickyCartContainer {
    display: none;
  }
}

@media (min-width: 1280px) {
  .header-first-line {
    padding-right: 9.7rem;
  }

  .main-menu-header {
    padding-right: 9rem;
  }
}

.cart-container {
  position: relative;
}

.cart {
  width: 15px;
  height: 15px;
  background: rgba(0, 0, 128, 0.7);
  top: -4px;
  position: absolute;
  right: -4px;
  color: #fff;
  font-size: 15px;
  text-align: center;
  font-weight: bold;
  border-radius: 10px;
}

.cart sup {
  top: -0.45em;
}

.mobile-cart sup {
  top: -0.4em;
}

</style>
<style scoped>
.popup-header {
  display: flex;
  align-items: center;
  justify-content: center; /* Centers the title */
  position: relative; /* Needed for the absolute positioning of the close button */
  padding: 0.5rem;
  border-bottom: 1px solid #ddd;
}

.popup-header-title {
  margin: 0;
}

.popup-close-button {
  position: absolute;
  right: 1rem; /* Adjust as needed */
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.addToCart {
  cursor: pointer;
}

.addToCartDisabled {
  background: #48bb78 !important;
  cursor: pointer;
}

#addToCart_wrapper a {
  cursor: pointer !important;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.bg-secondary {
  background-color: #6c757d !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: #545b62 !important;
}

.text-warning {
  color: #ffa260 !important
}

#follow-artist, #unfollow-artist {
  cursor: pointer;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
}

.soldB {
  margin: 0px auto;
  text-align: center;
  width: 65px;
  background-color: black;
  height: 65px;
  line-height: 65px;
  border-radius: 50%;
  font-size: 14px;
  color: rgb(255, 255, 255);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

/* Styles for the full popup */
.popup {
  position: fixed;
  bottom: 3%;
  left: 150px;
  transform: translateX(-50%);
  background: #fff;
  border: 1px solid #ccc;
  padding: 0px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  z-index: 9999;
  max-width: 250px !important;
}

/* Styles for the minimized popup */
.minimized-popup {
  position: fixed;
  bottom: 8%;
  left: 5%;
  background: darkred;
  border: none;
  padding: 10px 15px;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  color: white;
  font-weight: bold;
}

.popup-header {
  background: darkred;
  border: none;
  border-radius: 3px;
  color: white;
  font-weight: bold;
}
@media only screen and (max-width: 600px) {
  .popup {

    left: 30%;
    transform: translateX(-50%);
    background: #fff;
    border: 1px solid #ccc;
    padding: 0px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    z-index: 9999;
    max-width: 50% !important;
  }
}
</style>

<script>
import Dropdown from '@/Shared/Dropdown'
import FlashMessages from '@/Shared/FlashMessages'
import FooterLayout from '@/Shared/FooterLayout'
import FooterMenu from '@/Shared/FooterMenu'
// import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import MainMenu from '@/Shared/MainMenu'
import MainMenuDropdown from '@/Shared/MainMenuDropdown'
import TextInput from '@/Shared/TextInput'
import Newsletter from '@/Shared/Newsletter'
import i18n from '../../plugins/i18n';
import axios from "axios";
import MegaMenu from "./MegaMenu";
import eventBus from "../eventBus";

export default {
  components: {
    Dropdown,
    FlashMessages,
    // Icon,
    Logo,
    MainMenu,
    MainMenuDropdown,
    TextInput,
    FooterLayout,
    FooterMenu,
    Newsletter,
    MegaMenu
  },
  props: {
    title: String,
  },
  data() {
    return {
      popupVisible: false, // Controls if the popup is visible in full mode
      minimized: false,     // Controls if the popup is minimized
      showMegaMenu: false,
      ofertaZilei: null,
      categories: null,
      localeOfC: window.location.pathname.split('/')[1],
      showUserMenu: false,
      showSearchSuggestions: false,
      accounts: null,
      searchKeywords: null,
      navState: false,
      languages: [
        {
          flag: 'us', language: 'en', title: 'English'
        },
        {
          flag: 'ro', language: 'ro', title: 'Română'
        }
      ],
    }
  }
  ,
  methods: {
    addToCart(id) {
      let locale = window.location.pathname.split('/')[1];
      axios({
        method: "post",
        url: '/' + locale + '/cart/add/' + id
      }).then((response) => {
        if (response.data.status == 'success') {
          let carts = document.querySelectorAll('sup.cart_quantity');
          for (let i = 0, len = carts.length; i < len; ++i) {
            let cart = carts[i];
            cart.innerHTML = response.data.quantity;
          }
          this.minimizePopup();
          window.location.replace('/' + locale + '/cart');
        } else {
          this.$iziToast.show({
            message: response.data.message,
            color: 'red',
            position: null,
            target: "#iziToast-wrapper_cart_" + id,
            progressBar: false,
            timeout: 500000,
            displayMode: 'replace'//once
          });
        }
      });
    },
    makeLotTitle: function (lot, short = false) {
      let newArguments = [];
      let title = lot.title;
      if (short) {
        title = lot.shortened_title;
      }

      if (lot.heritage === 1) {
        newArguments.push('C');
      }
      if (lot.heritage === 2) {
        newArguments.push('F');
      }
      if (lot.heritage === 3) {
        newArguments.push('T');
      }
      if (lot.heritage === 4) {
        newArguments.push('IC');
      }
      if (lot.heritage === 5) {
        newArguments.push('IT');
      }
      if (lot.archive_preemption === 1) {
        newArguments.push('A');
      }

      if (newArguments.length > 0) {
        return '<sup>' + newArguments.join(", ") + '</sup> ' + title;
      } else {
        return title;
      }
    },
    makeArtistLink: function (artists) {
      var result = '';
      var locale = window.location.pathname.split('/')[1];
      artists.forEach(function (artist, i) {
        var end = '';
        if (i < artists.length - 1 && artists.length > 1) {
          end = '<span>, </span>';
        }
        if (artist.has_page) {
          result = result + '<span id="lotArtist"><a href="/' + locale + '/artist/' + artist.slug + '" style="text-decoration: underline">' + artist.name + end + '</a></span>';
        } else {
          result = result + '<span id="lotArtist">' + artist.name + end + '</span>';
        }
      })
      return result;
    },
    inArray(needle) {
      var haystack = Object.keys(this.$page.cart.items);
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    },
    minimizePopup() {
      // Hide the full popup and show the minimized version
      this.popupVisible = false;
      this.minimized = true;
    },
    restorePopup() {
      // Restore full popup from minimized state
      this.popupVisible = true;
      this.minimized = false;
    },
    hideDropdownMenus() {
      this.showUserMenu = false
    },
    url() {
      return location.pathname.substr(1)
    },
    search() {
      if (!this.searchKeywords) {
        return
      }

      const keywords = this.searchKeywords
      this.searchKeywords = ''
      if (this.isRo()) {
        window.location.href = 'https://dependentdearta.artmark.ro/ro/search/' + keywords
      } else {
        window.location.href = 'https://dependentdearta.artmark.ro/en/search/' + keywords
      }
      /*      return this.$inertia.visit(route('shop.search', {
              keywords: keywords
            }))*/
    }
    ,
    isOnHomepage() {
      return (window.location.pathname.split('/').length == 2 && (location.pathname == '/ro' || location.pathname == '/en')) ||
          (window.location.pathname.split('/').length == 3 && window.location.pathname.split('/')[3] == undefined && (location.pathname == '/ro/' || location.pathname == '/en/')) ||
          location.pathname.includes('/?anchor')
    }
    ,
    isRo() {
      return window.location.pathname.split('/')[1] === 'ro';
    },
    openNav() {
      this.navState = true;

      document.body.style.overflow = 'hidden';
      document.getElementById("stickyCartContainer").style.display = "none";
      document.getElementById("tidio-chat").style.display = "none";
    }
    ,
    closeNav() {
      this.navState = false;

      document.body.style.overflow = 'auto';
      document.getElementById("stickyCartContainer").style.display = "block";
      document.getElementById("tidio-chat").style.display = "block";
    },
    changeLocale(locale) {
      // i18n.locale = locale;
      var currentLocale = window.location.pathname.split('/')[1];
      var theURL = window.location.pathname;
      theURL = theURL.replace(currentLocale, locale);
      window.location.replace(theURL);
    },
    currentLocale() {
      // i18n.locale = locale;
      return '/' + window.location.pathname.split('/')[1];
    }
  },
  created() {
    let locale = window.location.pathname.split('/')[1];
    axios({
      method: "get",
      url: "/api/get-shop-categories/" + locale,
    }).then((response) => {
      this.categories = response.data
    }).catch(function (error) {

    });
    axios({
      method: "get",
      url: "/api/get-shop-oferta-zilei",
    }).then((response) => {
      this.ofertaZilei = response.data
    }).catch(function (error) {

    });
  },
  mounted() {
    setTimeout(() => {
      if (this.ofertaZilei.length > 0) {
        this.popupVisible = true;
      }
    }, 2000);
    eventBus.$on("show-mega-menu", () => {
      this.showMegaMenu = true;
    });
    eventBus.$on("hide-mega-menu", () => {
      this.showMegaMenu = false;
    });
  }
}
</script>
